import * as yup from 'yup';
import { eDepositCategory } from '../../../../types/order/escrow/eDepositCategory';
import { eAchPullPayerType } from '../../../../types/order/escrow/eAchPullPayerType';

const alphaNumericRE: RegExp = /^[a-zA-Z\d]+$/;

export const IncomingACHValidationSchema = ({ amountCentsMax }: { amountCentsMax: number }) =>
  yup.object({
    amountCents: amountCentsMax
      ? yup
          .number()
          .typeError('Amount must be a number')
          .positive()
          .max(amountCentsMax, `Amount can not be more than ${amountCentsMax / 100}`)
          .required('This is required')
      : yup.number().typeError('Amount must be a number').positive().required('This is required'),
    category: yup.mixed<eDepositCategory>().required('This is required'),
    wellsFargoTransactionNumber: yup
      .string()
      .matches(alphaNumericRE, 'Only numbers and letters are valid inputs')
      .required('This is required')
      .typeError('This is required'),
    payerType: yup.mixed<eAchPullPayerType>().required('This is required'),
    ownerId: yup.string().nullable(),
  });

export const IncomingAchDepositValidationSchema = yup.object({
  achDeposits: yup.array(IncomingACHValidationSchema({ amountCentsMax: 0 })),
});
